<script>
export default {
    name: "StatDashboard",
    props: {
        title: {
            default: ""
        },
        value: {
            default: 1
        }
   }
};
</script>

<template>
    <div class="card mini-stats-wid">
        <div class="card-body pm-default">
            <div class="d-flex">
                <div class="flex-grow-1">
                <p class="text-muted fw-medium mb-2">{{title}}</p>
                <h4 class="mb-0">{{ value }}</h4>
                </div>

                <div class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-primary">
                <span class="avatar-title">
                    <i class="bx bx-copy-alt font-size-24"></i>
                </span>
                </div>
            </div>
        </div>
        <!-- end card-body -->
    </div>
</template>
